<template>
    <span
        v-tooltip.bottom="{ value: formatDate(momentDatetime, 'LLL zz'), class: 'datetime-display__tooltip' }"
        :class="isLarge ? 'tw:text-lg' : 'tw:text-sm'"
    >
        <span v-if="calendar">{{ momentDatetime.calendar() }}</span>
        <span v-else>{{ formatDate(momentDatetime, format) }}</span>
    </span>
</template>

<script>
export default {
    name: 'DatetimeDisplay',

    props: {
        datetime: {
            type: [Object, String],
            required: true,
        },

        isLarge: {
            type: Boolean,
            required: false,
            default: false,
        },

        format: {
            type: String,
            required: false,
            default: 'LLL zz',
        },

        calendar: {
            type: Boolean,
            required: false,
            default: false,
        },

        local: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        momentDatetime() {
            if (typeof this.datetime === 'string') {
                return this.local
                    ? this.$moment(this.datetime)
                    : this.$moment.utc(this.datetime).tz(this.$timezone.name);
            }

            return this.datetime;
        },
    },
};
</script>

<style>
.p-tooltip.datetime-display__tooltip {
    max-width: 25rem;
    margin-top: 0.5rem;
}

.datetime-display__tooltip .p-tooltip-text {
    position: relative;
}

.datetime-display__tooltip .p-tooltip-text::before {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 100%;
    transform: translateX(-50%);
    border: 0.375rem solid transparent;
    border-bottom-color: var(--p-tooltip-background, #334155);
}
</style>
